import { crudOperations } from './api';

class JobCategoryService {
  /**
   * Get all job categories with hierarchical structure
   * @returns {Promise<Array>} Array of job categories
   */
  async getJobCategories() {
    try {
      const response = await crudOperations.get('/job-categories');
      return response.data.categories || [];
    } catch (error) {
      console.error('Error fetching job categories:', error);
      throw error;
    }
  }

  /**
   * Get job categories organized by level for dropdown population
   * @returns {Promise<Object>} Object with level1, level2, level3 arrays
   */
  async getJobCategoriesForDropdown() {
    try {
      const categories = await this.getJobCategories();
      
      const organized = {
        level1: [],
        level2: {},
        level3: {}
      };
      
      categories.forEach(category => {
        if (category.category_level === 1) {
          organized.level1.push(category);
        } else if (category.category_level === 2) {
          if (!organized.level2[category.parent_id]) {
            organized.level2[category.parent_id] = [];
          }
          organized.level2[category.parent_id].push(category);
        } else if (category.category_level === 3) {
          if (!organized.level3[category.parent_id]) {
            organized.level3[category.parent_id] = [];
          }
          organized.level3[category.parent_id].push(category);
        }
      });
      
      return organized;
    } catch (error) {
      console.error('Error organizing job categories:', error);
      throw error;
    }
  }

  /**
   * Get a specific job category by ID
   * @param {string} categoryId - The category ID
   * @returns {Promise<Object>} Category object
   */
  async getJobCategory(categoryId) {
    try {
      const response = await crudOperations.get(`/job-categories/${categoryId}`);
      return response.data.category;
    } catch (error) {
      console.error('Error fetching job category:', error);
      throw error;
    }
  }

  /**
   * Get full path display for a category
   * @param {Array} categories - All categories array
   * @param {string} categoryId - The category ID
   * @returns {string} Full path string
   */
  getFullPath(categories, categoryId) {
    const category = categories.find(cat => cat.id === categoryId);
    return category ? category.full_path : '';
  }
}

const jobCategoryService = new JobCategoryService();
export default jobCategoryService;